import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

import {makeStyles} from '@material-ui/core/styles';
import {Form} from 'react-final-form';

import {setErrorInformation, toggleLoader} from '../../redux/application'

import Button from '../adapters/Button';
import TextField from '../adapters/TextField';
import LoginWithSign from './LoginWithSign';
import Register from './Register';
import ChangePasswordAskEmail from './ChangePasswordAskEmail';

import {loginByLoginPass} from '../../redux/user';
import {validateEmail} from "../../utils/utils";


const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      //marginTop: theme.spacing(3),
    }
  })
);


export function Login(props) {
  //const location = useLocation();
  const dispatch = useDispatch();

  const [isOpenSignDlg, toggleSignDlg] = useState(false);
  const [isOpenRegisterDlg, toggleRegisterDlg] = useState(false);
  const [isOpenChangePasswDlg, toggleChangePasswDlg] = useState(false);

  const classes = useStyles();

  async function onSubmit(values) {
    //dispatch(toggleLoader(true));
    dispatch(loginByLoginPass(values));
  }

  async function test() {
    dispatch(toggleLoader(false));
    //await SignLib.SW_initIfNeeded();
    dispatch(setErrorInformation('Херня'));
    //await SignLib.init();
  }

  function validate(values) {
    let errors = {};
    if (!values.login)
      errors.login = 'Необхідно заповнити поле "Логін (адреса електронної пошти)"';
    if (values.login && validateEmail(values.login))
      errors.login = 'Введено некоректну адресу електронної пошти'
    if (!values.password)
      errors.password = 'Необхідно заповнити поле "Пароль"';
    return errors;
  }

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Typography variant="h5" noWrap>
          Особистий електронний кабінет здобувача
        </Typography>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          render={({handleSubmit, hasValidationErrors}) => (
            <form className={classes.form} onSubmit={handleSubmit} noValidate>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField name="login" label="Логін (адреса електронної пошти)" required/>
                </Grid>
                <Grid item xs={12}>
                  <TextField name="password" label="Пароль" type="password" required/>
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" color="primary" fullWidth
                          disabled={hasValidationErrors}>Вхід</Button>
                </Grid>
              </Grid>
            </form>
          )}
        />

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Link component="button" onClick={() => toggleChangePasswDlg(true)}>Забули пароль?</Link>
          </Grid>
          <Grid item xs={12}>
            <Link component="button" onClick={() => toggleSignDlg(true)}>Ви також можете авторизуватись за допомогою
              КЕП</Link>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" fullWidth onClick={() => toggleRegisterDlg(true)}>Реєстрація</Button>
          </Grid>
        </Grid>
      </div>
      <LoginWithSign open={isOpenSignDlg} toggle={toggleSignDlg}/>
      <Register open={isOpenRegisterDlg} toggle={toggleRegisterDlg} />
      <ChangePasswordAskEmail open={isOpenChangePasswDlg} toggle={toggleChangePasswDlg} />
    </Container>
  );
}

